import React from 'react';
import App from '../App';
import { useUrlCloaking } from '../hooks/useUrlCloaking';

/**
 * Legacy query-string entry point ("/").
 *
 * Renders <App> immediately with the in-memory params (so the flow always
 * works, even offline), and in the background creates an opaque session and
 * rewrites the URL to /compliance/{sessionId} to hide the params from the
 * address bar.
 *
 * If session creation fails, the app keeps working with the original URL —
 * cloaking is best-effort and never blocks ID/KYC upload.
 */
function LegacyEntry(props) {
  const token = process.env.REACT_APP_TOKEN_PASS;
  const baseUrl = (process.env.REACT_APP_URL_VIACHEK_MOBILE || '').replace(
    '{NAME_REGION}',
    props.region || ''
  );

  // URL cloaking is ON by default. Set REACT_APP_URL_CLOAKING="false" to
  // disable it (kill switch) — the app then keeps the legacy query-string URL
  // without creating a session. No code change or redeploy of logic needed.
  const cloakingEnabled = process.env.REACT_APP_URL_CLOAKING !== 'false';

  useUrlCloaking({ baseUrl, token, enabled: cloakingEnabled });

  return <App {...props} />;
}

export default LegacyEntry;
